import { useEffect } from 'react';

import { useSSOAuth } from 'modules/auth/hooks/useSSOAuth';

export const RedirectToAuthPage = () => {
  const { handleSignIn } = useSSOAuth();

  useEffect(handleSignIn);

  return null;
};
